import { lazy, Suspense } from 'react';

import { PageLoader } from '@components/ui/PageLoader';

const EditProfilePageLazy = lazy(() => import('./edit-profile-page'));
const SecurityPageLazy = lazy(() => import('./security-page'));
const PasswordPageLazy = lazy(() => import('./password-page'));
const SettingsLayoutLazy = lazy(() => import('./layout'));
const NotificationsPageLazy = lazy(() => import('./notifications-page'));
const LimitsPageLazy = lazy(() => import('./limits-page'));
const BillingPageLazy = lazy(() => import('./billing-page'));
const CommissionsPageLazy = lazy(() => import('./commissions-page'));

const SettingsLayoutAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <SettingsLayoutLazy />
    </Suspense>
  );
};

const EditProfilePageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <EditProfilePageLazy />
    </Suspense>
  );
};

const SecurityPageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <SecurityPageLazy />
    </Suspense>
  );
};

const PasswordPageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <PasswordPageLazy />
    </Suspense>
  );
};

const NotificationSettingsAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <NotificationsPageLazy />
    </Suspense>
  );
};

const LimitsPageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <LimitsPageLazy />
    </Suspense>
  );
};

const BillingPageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <BillingPageLazy />
    </Suspense>
  );
};

const CommissionsPageAsync = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <CommissionsPageLazy />
    </Suspense>
  );
};

export {
  SettingsLayoutAsync as SettingsLayout,
  SecurityPageAsync as SecurityPage,
  EditProfilePageAsync as EditProfilePage,
  PasswordPageAsync as PasswordPage,
  NotificationSettingsAsync as NotificationSettings,
  LimitsPageAsync as LimitsPage,
  BillingPageAsync as BillingPage,
  CommissionsPageAsync as CommissionsPage,
};
